<template>
  <facquick-card title="Additional Charges">
    <template v-slot:header-actions>
      <v-btn color="primary" icon class="elevation-3" @click="showD=!showD">
        <v-icon>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
       <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
    </template>
    <template v-slot:card-content>
      <v-data-table
        :headers="fee_item_headers"
        :items="adcharges"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.charge_item }}</td>
          <td class="text-xs-center">{{ props.item.amount | toCurrency}}</td>
          <td class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs6>
                <v-btn flat icon color="blue" @click="editadcharge(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6>
                <v-btn flat icon color="pink" @click="deleteadcharge(props.item, props.item.index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>

      <m-dialog title="Additional Charge" :show="showD" pers>
        <template v-slot:header-actions>
          <v-btn @click="showD=!showD" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form">
            <v-text-field label="Charged Item" v-model="adcharge_model.charge_item" :rules="validRules.required"/>

            <v-text-field label="Amount(GHS)" v-model="adcharge_model.amount" type="number" step="any" :rules="validRules.required"/>

          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn style="cursor:pointer" color="success" @click="saveadcharge()">save</v-btn>
          <v-btn @click="showD=!showD" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </m-dialog>
    </template>
  </facquick-card>
</template>

<script>
import { mapGetters } from "vuex";
import QuickCard from "../Quickcard";
import Mdialog from "../Modal";
export default {
  name: "additional-charges",
  components: {
    "facquick-card": QuickCard,
    "m-dialog": Mdialog
  },
  data() {
    return {
      showD: false,
      pers: false,
      search: "",
      editedIndex: -1,
      adcharge_model: {
        charge_item: "",
        amount: ""
      },
      adcharge_modelcp: {
        item: "",
        amount: ""
      },
      fee_item_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn"
        },
        {
          text: "Charged Item",
          align: "center",
          sortable: false,
          value: "charge_item"
        },
        {
          text: "Amount(GHS)",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("adcharges/getAll");

    //console.log("adchargesooooo",adcharges)
  },
  computed: {
    ...mapGetters({
      adcharges: "adcharges/ADCHARGES",
      faerrors: "adcharges/ADCHARGE_ERROR",
      loading: "adcharges/ADCHARGE_LOADING"
    })
  },
  methods: {
    addadcharge() {
      this.$store.dispatch("adcharges/add", this.adcharge_model);

      if (this.faerrors ==null) {
        this.adcharge_model = this.adcharge_modelcp;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Charge saved successfully",
                title: "Additional Charges",
                modal: false
            })
      }
    },
    deleteadcharge(adcharge, index) {
      if (confirm("Are you sure you want to delete this adcharge?")) {
        this.$store.dispatch("adcharges/delete", { adcharge, index });
         this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Charge deleted successfully",
                title: "Additional Charges",
                modal: false
            })
      }
    },

    editadcharge(adcharge) {
      this.editedIndex = this.adcharges.indexOf(adcharge);
      this.adcharge_model = Object.assign({}, adcharge);

      //alert(this.editedIndex)

      this.showD = true;
    },
    updateadcharge(adcharge, index) {
      this.$store.dispatch("adcharges/update", { index, adcharge });

      if (this.faerrors ==null) {
        this.adcharge_model = this.adcharge_modelcp;
        this.editedIndex = -1;
        this.showD = false;
         this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Charge updated successfully",
                title: "Additional Charges",
                modal: false
            })
      }
    },
    saveadcharge() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing adcharge info or saving adcharge info
      if (this.editedIndex > -1) {
        this.updateadcharge(this.adcharge_model, this.editedIndex);
      } else {
        this.addadcharge();
      }
    }
  },
  watch: {
    showD(val) {
      if (val == false) {
        this.adcharge_model = {};
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/feesAdditionalCharges.vue